<template>
	<div>
		<multi-select label="Groups" :items="groups" v-model="selected" item-text="name" item-value="uuid"></multi-select>
	</div>
</template>

<script>
import MultiSelect from '@/components/MultiSelect'

export default {
	components: {
		MultiSelect
	},
	 props: {
    'value': {
      type: Array,
      default () { return []; }
    }
  },
  data () {
  	return {
  		val: this.get_initial_value()
  	}
  },
  created () {
  },
  methods: {
  	get_initial_value() {
  		if (this.value.length == 0) {
				var new_value = [this.$store.getters.account_default_group.uuid];
				this.$emit("input", new_value);
				return new_value;
  		} else {
  			return _.cloneDeep(this.value);
  		}
  	}
  },
  computed: {
  	selected: {
  		get() {

  			return this.val;
  		},
  		set(newVal) {
	  		this.val = newVal;
  			this.$emit("input", this.val);
  		}
  	},
  	groups () {
  		return Object.values(this.$store.getters.groups);
  	}
  }
}
</script>